import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import WorksSection from "./components/WorksSection";
import GuideSection from "./components/GuideSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "什么是火影同人本子？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "火影同人本子是由爱好者围绕《火影忍者》世界观与角色创作的原创漫画或短篇合集，会按作者偏好重新演绎角色关系，常见按CP（角色配对）分类。",
      },
    },
    {
      "@type": "Question",
      name: "鸣人CP与佐助CP有什么不同？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "鸣人CP偏向阳光羁绊与并肩成长，整体氛围明亮热血；佐助CP更多刻画孤独、复仇与救赎的复杂心绪，剧情与情感向作品居多。",
      },
    },
    {
      "@type": "Question",
      name: "鼬樱、卡卡西、鹿丸、我爱罗这几类有什么特色？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "鼬樱偏含蓄守护与细腻情感，卡卡西以温情日常和师恩回忆为主，鹿丸走轻松机智的反差风格，我爱罗则聚焦孤独、守护与重新学会信任。",
      },
    },
  ],
};

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("全部");

  const handleSelect = (name: string) => {
    setActiveCategory(name);
    if (name !== "全部") {
      const el = document.getElementById("hot");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <main className="min-h-screen w-full bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <Hero />
      <CategorySection activeCategory={activeCategory} onSelect={handleSelect} />
      <WorksSection activeCategory={activeCategory} onSelect={setActiveCategory} />
      <GuideSection />
      <AboutSection />
      <FaqSection />
      <ContactSection />
      <Footer />
      <BackToTop />
    </main>
  );
}